// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-document[data-v-2374294d]{width:20px;height:20px}.mr-2[data-v-2374294d]{margin-right:.3rem}.white-space[data-v-2374294d]{white-space:pre-wrap}.check-icon[data-v-2374294d]{width:16px;height:12px;margin-bottom:-1px}.alert-icon[data-v-2374294d]{width:18px;height:14px;margin-bottom:-1px}.filename[data-v-2374294d]{word-wrap:anywhere}.documentname[data-v-2374294d]{font-weight:500}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
